import React from 'react'
import {
  Inject,
  ProgressBarComponent,
  ProgressAnnotation,
  ProgressBarAnnotationsDirective,
  ProgressBarAnnotationDirective,
} from '@syncfusion/ej2-react-progressbar'
import { DashboardUnits } from '@dataTypes/dashboard.types'
import { formatValueByUnit } from '@utils/index'

import '../DashboardStyle.css'

type ProgressBarProps = {
  title: string
  goal: number
  actual: number
  unit: DashboardUnits
  maxValue?: number
  minValue?: number
  height?: string
  width?: string
  displayPercent?: boolean
}

function ProgressBar({
  title,
  goal,
  actual,
  maxValue,
  minValue,
  unit,
  height,
  width,
  displayPercent,
}: ProgressBarProps): React.ReactElement {
  const progressPercentage = (actual / goal) * 100

  const displayText = displayPercent
    ? formatValueByUnit(progressPercentage, unit)
    : formatValueByUnit(actual, unit)

  const content = `<div id="${title}"
    style="display:flex; justify-content:center; align-items:center;
    height:100%; width:100%; font-size:1.85rem; font-weight:semi-bold; color:#000;">
      <span>${displayText}</span>
    </div>`

  return (
    <div className="dashboard-control-pane" key={title}>
      <div className="dashboard-control-section">
        <ProgressBarComponent
          id={title}
          type="Circular"
          width={height ?? '150'}
          height={width ?? '150'}
          trackThickness={15}
          progressThickness={15}
          value={progressPercentage}
          minimum={minValue ?? 0}
          maximum={maxValue ?? 100}
        >
          <Inject services={[ProgressAnnotation]} />
          <ProgressBarAnnotationsDirective>
            <ProgressBarAnnotationDirective content={content} />
          </ProgressBarAnnotationsDirective>
        </ProgressBarComponent>
      </div>
    </div>
  )
}

export default ProgressBar
